export const YOUTUBE_VIDEO = 'YOUTUBE_VIDEO';
export const VIDEO = 'VIDEO';
export const FILE = 'FILE';
